import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ButtonGhost = ({ className, children, ...props }) => {
    return (
        <button
            type="button"
            className={classNames('odf-btn', 'odf-btn-ghost', className)}
            {...props}
        >
            {children}
        </button>
    );
};

ButtonGhost.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

ButtonGhost.defaultProps = {
    className: '',
    children: null,
};

export { ButtonGhost };
